import script from "./InventoryTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryTable.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryTable.vue?vue&type=style&index=0&id=1205199d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1205199d"]])

export default __exports__